import React from 'react';
import PropTypes from 'prop-types';

import { Dropdown as BootstrapDropdown } from 'react-bootstrap-5';

import Cell from './cell';
import Control from './control';
import MenuItem from './menu_item';
import MenuItems from './menu_items';
import ParentItem from './parent_item';
import PortalMenu from './portal_menu';

import './styles.scss';

// The modifier ensures the menu gets positioned correctly the first time
// Without it, there's some ref assignmetn timing issue that mispositions it
export default function Dropdown({
  align = 'end',
  children,
  controlProps,
  disabled,
  icon,
  label,
  portal,
  size,
  variant,
  ...props
}) {
  return (
    <BootstrapDropdown align={align} {...props}>
      <Control
        disabled={disabled}
        icon={icon}
        label={label}
        size={size}
        variant={variant}
        {...controlProps}
      />

      <BootstrapDropdown.Menu
        {...(portal && { as: PortalMenu })}
        popperConfig={{
          strategy: 'fixed',
          modifiers: [{
            name: 'forceUpdate',
            enabled: true,
            phase: 'afterWrite',
            fn({ state, instance }) {
              if (!state.forceUpdateDone) {
                state.forceUpdateDone = true;
                requestAnimationFrame(() => instance.update());
              }
            },
          }],
        }}
      >
        {children}
      </BootstrapDropdown.Menu>
    </BootstrapDropdown>
  );
}

Dropdown.propTypes = {
  align: PropTypes.string,
  children: PropTypes.node,
  controlProps: PropTypes.object,
  disabled: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  label: PropTypes.string,
  portal: PropTypes.bool,
  size: PropTypes.string,
  variant: PropTypes.string,
};

Dropdown.Cell = Cell;
Dropdown.Divider = BootstrapDropdown.Divider;
Dropdown.Item = MenuItem;
Dropdown.MenuItems = MenuItems;
Dropdown.ParentItem = ParentItem;
